import React from 'react'

import ModalV5 from "../../../../app/ui/modal/v5/v5"
import ModalV5_Header from "../../../../app/ui/modal/v5/header/header"
import ModalAddUser_Main from "./main"
import {AddUser_Manager} from "../model/manager"
import ErrorBoundary from "../../../error-boundary"

// const debug = "ModalUpgrade"
const debug = false

type Props = {
    manager     : AddUser_Manager
}

export default function ModalAddUser(props:Props) {
    return (
        <ModalV5 className="w-950i h-650 flex-row">


            <ErrorBoundary>
                <ModalAddUser_Main manager={props.manager} />
            </ErrorBoundary>
        </ModalV5>
    )
}